import { render, staticRenderFns } from "./CompanyDetail.vue?vue&type=template&id=68456946&scoped=true&"
import script from "./CompanyDetail.vue?vue&type=script&lang=ts&"
export * from "./CompanyDetail.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyDetail.vue?vue&type=style&index=0&id=68456946&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68456946",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VCard,VContainer,VIcon,VMenu})
